import SizeChartMenu from './SizeChartMenu'

export default SizeChartMenu
